const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M63.2,421.5C109.8,474.5,178,508,254,508c76.1,0,144.3-33.5,190.8-86.5H63.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 172.7,
    style: {
      fill: "#FFD05B"
    },
    width: 245.7,
    height: 198.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 362.1,
    y: 172.7,
    style: {
      fill: "#F9B54C"
    },
    width: 7.2,
    height: 198.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.9,
    y: 172.7,
    style: {
      fill: "#F9B54C"
    },
    width: 7.2,
    height: 198.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 172.7,
    style: {
      fill: "#F9B54C"
    },
    width: 7.2,
    height: 198.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.6,
    y: 172.7,
    style: {
      fill: "#F9B54C"
    },
    width: 7.2,
    height: 198.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 172.7,
    style: {
      fill: "#F9B54C"
    },
    width: 7.2,
    height: 198.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 207.5,
    style: {
      fill: "#E6E9EE"
    },
    width: 245.7,
    height: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 385.3,
    cy: 220.7,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 343.3,
    cy: 220.7,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 301.4,
    cy: 220.7,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 259.5,
    cy: 220.7,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 217.5,
    cy: 220.7,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 175.6,
    cy: 220.7,
    r: 4.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 313,
    style: {
      fill: "#E6E9EE"
    },
    width: 245.7,
    height: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 385.3,
    cy: 326.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 343.3,
    cy: 326.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 301.4,
    cy: 326.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 259.5,
    cy: 326.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 217.5,
    cy: 326.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 175.6,
    cy: 326.3,
    r: 4.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M424.2,384.3H122c-4.4,0-7.9-3.6-7.9-7.9V180.1l-37.5-37.5c-3.1-3.1-3.1-8.1,0-11.2 c3.1-3.1,8.1-3.1,11.2,0l39.8,39.8c1.5,1.5,2.3,3.5,2.3,5.6v191.6h294.3c4.4,0,7.9,3.6,7.9,7.9S428.5,384.3,424.2,384.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B3B4E"
    },
    cx: 382.7,
    cy: 392.8,
    r: 29.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6E9EE"
    },
    cx: 382.7,
    cy: 392.8,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B3B4E"
    },
    cx: 169.8,
    cy: 392.8,
    r: 29.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6E9EE"
    },
    cx: 169.8,
    cy: 392.8,
    r: 18
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.24b9766d4dbbc90f7d6058cc1e1dba7f.svg";
export { ForwardRef as ReactComponent };